import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeTeacherGuideFields {
  subscriptionType: EntryFieldTypes.Symbol<'Maths' | 'Reading'>
  role: EntryFieldTypes.Array<EntryFieldTypes.Symbol<'Subco' | 'Teacher'>>
  title: EntryFieldTypes.Symbol
  description?: EntryFieldTypes.Text
  cover: EntryFieldTypes.AssetLink
  file: EntryFieldTypes.AssetLink
  domains: EntryFieldTypes.Array<
    EntryFieldTypes.Symbol<'all' | 'au' | 'ca' | 'cn' | 'in' | 'int' | 'kr' | 'nz' | 'th' | 'uk' | 'us' | 'za'>
  >
  product?: EntryFieldTypes.Symbol<'fast_phonics' | 'mathseeds' | 'reading_eggs' | 'reading_eggspress'>
  internalName?: EntryFieldTypes.Symbol
}

export type TypeTeacherGuideSkeleton = EntrySkeletonType<TypeTeacherGuideFields, 'teacherGuide'>
export type TypeTeacherGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeTeacherGuideSkeleton,
  Modifiers,
  Locales
>

export function isTypeTeacherGuide<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTeacherGuide<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'teacherGuide'
}

export type TypeTeacherGuideWithoutLinkResolutionResponse = TypeTeacherGuide<'WITHOUT_LINK_RESOLUTION'>
export type TypeTeacherGuideWithoutUnresolvableLinksResponse = TypeTeacherGuide<'WITHOUT_UNRESOLVABLE_LINKS'>
export type TypeTeacherGuideWithAllLocalesResponse<Locales extends LocaleCode = LocaleCode> = TypeTeacherGuide<
  'WITH_ALL_LOCALES',
  Locales
>
export type TypeTeacherGuideWithAllLocalesAndWithoutLinkResolutionResponse<Locales extends LocaleCode = LocaleCode> =
  TypeTeacherGuide<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>
export type TypeTeacherGuideWithAllLocalesAndWithoutUnresolvableLinksResponse<Locales extends LocaleCode = LocaleCode> =
  TypeTeacherGuide<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>
